import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { Button, Paper, FormControlLabel, Switch } from '@mui/material'
import { Autocomplete, Grid } from '../../../UniversalComponents'
import { useAuth } from '../../../../context/AuthenticationContext'
import { permissionsCheck } from '../../../../utilities/functionTools'

interface FleetAnalyticsFilterProps {
    startDate: any
    endDate: any
    telemetryType: string
    telemetryOptions: string[]
    fullHin?: string
    fullHinOptions: any
    setFilter: (e: any) => void
    handleSubmit: (e: any) => void
    datagridView: boolean
}
const FleetAnalyticsFilter = ({
    startDate,
    endDate,
    telemetryType,
    telemetryOptions,
    fullHin,
    fullHinOptions,
    setFilter,
    handleSubmit,
    datagridView,
}: FleetAnalyticsFilterProps) => {
    const currentUser = useAuth()
    const { userProfile } = currentUser.auth
    const { superAdmin, userProfilePermissions } = userProfile
    return (
        <Paper sx={{ padding: 5 }} elevation={4}>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            views={['year', 'month', 'day']}
                            sx={{ width: '100%' }}
                            value={startDate}
                            onChange={({ $d }: any) => {
                                const event = {
                                    target: {
                                        value: $d,
                                        name: 'startDate',
                                    },
                                }
                                setFilter(event)
                            }}
                            slotProps={{
                                textField: {
                                    error: false,
                                },
                            }}
                            disabled={permissionsCheck(
                                userProfilePermissions,
                                'Fleet Analytics'
                            )}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            views={['year', 'month', 'day']}
                            sx={{ width: '100%' }}
                            value={endDate}
                            onChange={({ $d }: any) => {
                                const event = {
                                    target: {
                                        value: $d,
                                        name: 'endDate',
                                    },
                                }
                                setFilter(event)
                            }}
                            slotProps={{
                                textField: {
                                    error: false,
                                },
                            }}
                            disabled={permissionsCheck(
                                userProfilePermissions,
                                'Fleet Analytics'
                            )}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                    <Autocomplete
                        options={telemetryOptions}
                        handleChange={setFilter}
                        value={telemetryType}
                        fullWidth
                        label="Telemetry Type"
                        name="telemetryType"
                        disableClearable={true}
                        disabled={permissionsCheck(
                            userProfilePermissions,
                            'Fleet Analytics'
                        )}
                    />
                </Grid>
                <Grid item xs={2}>
                    <Autocomplete
                        options={fullHinOptions}
                        handleChange={setFilter}
                        value={fullHin}
                        fullWidth
                        label="Generate Report By Hin"
                        name="boatId"
                        disabled={permissionsCheck(
                            userProfilePermissions,
                            'Fleet Analytics'
                        )}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel
                        control={
                            <Switch
                                onChange={setFilter}
                                inputProps={{
                                    'aria-label': 'controlled',
                                }}
                                id="datagridView"
                                name="datagridView"
                                checked={datagridView}
                                key="switch.datagridView"
                            />
                        }
                        label="Datagrid View"
                        key="switch.datagridView"
                        disabled={permissionsCheck(
                            userProfilePermissions,
                            'Fleet Analytics'
                        )}
                    />
                </Grid>
                <Grid item xs={2}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{
                            height: 55,
                        }}
                        disabled={permissionsCheck(
                            userProfilePermissions,
                            'Fleet Analytics'
                        )}
                    >
                        Generate New Report
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default FleetAnalyticsFilter
